import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '../../../environments/environment'
import { Observable } from 'rxjs'

@Injectable()
export class ContactTypesService {
  constructor(private http: HttpClient) {}

  public fetchContactTypes(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/contactTypes`
    return this.http.post(url, params)
  }
  public fetchContactType(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/contactType/${id}`
    return this.http.get(url, {})
  }

  public deleteContactType(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/contactType/${id}`
    return this.http.delete(url)
  }

  public createContactType(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/contactType`
    return this.http.post(url, params)
  }

  public updateContactType(id: number, params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/contactType/${id}`
    return this.http.put(url, params)
  }
}
